// 产品SKU配置文件
// SKU结构：产品类型 + 用户配置 + 有效期

export const SKU_DIMENSIONS = {
  // 产品类型（4种）
  PRODUCT_TYPES: {
    OFFICIAL: 'official',                    // 官网独享账号
    OFFICIAL_RENEWAL: 'official-renewal',    // 官网账号续费
    OFFICIAL_SHARED: 'official-shared',      // 官网共享账号
    // SHARED: 'shared',                        // 网页共享托管账号
    // MONKEYAI: 'monkeyai'                     // MonkeyAI
  },
  
  // 用户配置（子类）
  USER_CONFIGS: {
    ONE_USER: '1user',        // 1人独享/共享
    THREE_USERS: '3users',    // 3人共享
    SIX_USERS: '6users'       // 6人共享
  },
  
  // 有效期
  DURATIONS: {
    ONE_MONTH: '1month',
    THREE_MONTHS: '3months',
    TWELVE_MONTHS: '12months'
  }
};

// SKU配置映射
export const SKU_CONFIG = {
  // 官网独享账号（1人独享）
  'official-1user-1month': {
    id: 'official-1user-1month',
    productType: 'official',
    userConfig: '1user',
    duration: '1month',
    productId: 240,
    product_days: 30,
    type: 'app1',
    product_name: 'ChatGPT $20 Plus Official Account 1 Month',
    nameKey: 'sku.official.1user.1month.name',
    descriptionKey: 'sku.official.1user.1month.description',
    price: 17.9,
    originalPrice: 20,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: true,
      privacy: 'private'
    }
  },
  'official-1user-3months': {
    id: 'official-1user-3months',
    productType: 'official',
    userConfig: '1user',
    duration: '3months',
    productId: 241,
    product_days: 90,
    type: 'app1',
    product_name: 'ChatGPT $20 Plus Official Account 3 Months',
    nameKey: 'sku.official.1user.3months.name',
    descriptionKey: 'sku.official.1user.3months.description',
    price: 53.7,
    originalPrice: 60,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: true,
      privacy: 'private'
    }
  },
  'official-1user-12months': {
    id: 'official-1user-12months',
    productType: 'official',
    userConfig: '1user',
    duration: '12months',
    productId: 242,
    product_days: 365,
    type: 'app1',
    product_name: 'ChatGPT $20 Plus Official Account 12 Months',
    nameKey: 'sku.official.1user.12months.name',
    descriptionKey: 'sku.official.1user.12months.description',
    price: 214.8,
    originalPrice: 240,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: true,
      privacy: 'private'
    }
  },
  
  // 官网账号续费（1人独享）
  'official-renewal-1user-1month': {
    id: 'official-renewal-1user-1month',
    productType: 'official-renewal',
    userConfig: '1user',
    duration: '1month',
    productId: 243,
    product_days: 30,
    type: 'renew',
    product_name: 'ChatGPT $20 Plus Official Renewal 1 Month',
    nameKey: 'sku.officialRenewal.1user.1month.name',
    descriptionKey: 'sku.officialRenewal.1user.1month.description',
    price: 17.9,
    originalPrice: 20,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      renewalOnly: true,
      passwordChangeable: true,
      privacy: 'private'
    }
  },
  'official-renewal-1user-3months': {
    id: 'official-renewal-1user-3months',
    productType: 'official-renewal',
    userConfig: '1user',
    duration: '3months',
    productId: 244,
    product_days: 90,
    type: 'renew',
    product_name: 'ChatGPT $20 Plus Official Renewal 3 Months',
    nameKey: 'sku.officialRenewal.1user.3months.name',
    descriptionKey: 'sku.officialRenewal.1user.3months.description',
    price: 53.7,
    originalPrice: 60,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      renewalOnly: true,
      passwordChangeable: true,
      privacy: 'private'
    }
  },
  'official-renewal-1user-12months': {
    id: 'official-renewal-1user-12months',
    productType: 'official-renewal',
    userConfig: '1user',
    duration: '12months',
    productId: 245,
    product_days: 365,
    type: 'renew',
    product_name: 'ChatGPT $20 Plus Official Renewal 12 Months',
    nameKey: 'sku.officialRenewal.1user.12months.name',
    descriptionKey: 'sku.officialRenewal.1user.12months.description',
    price: 214.8,
    originalPrice: 240,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      renewalOnly: true,
      passwordChangeable: true,
      privacy: 'private'
    }
  },
  
  // 官网共享账号（3人共享）
  'official-shared-3users-1month': {
    id: 'official-shared-3users-1month',
    productType: 'official-shared',
    userConfig: '3users',
    duration: '1month',
    productId: 246,
    product_days: 30,
    type: 'app3',
    product_name: 'ChatGPT $20 Plus Official Shared 3 Users 1 Month',
    nameKey: 'sku.officialShared.3users.1month.name',
    descriptionKey: 'sku.officialShared.3users.1month.description',
    price: 9.9,
    originalPrice: 20,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 3,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: false,
      privacy: 'shared',
      chatDeletable: false
    }
  },
  'official-shared-3users-3months': {
    id: 'official-shared-3users-3months',
    productType: 'official-shared',
    userConfig: '3users',
    duration: '3months',
    productId: 247,
    product_days: 90,
    type: 'app3',
    product_name: 'ChatGPT $20 Plus Official Shared 3 Users 3 Months',
    nameKey: 'sku.officialShared.3users.3months.name',
    descriptionKey: 'sku.officialShared.3users.3months.description',
    price: 29.7,
    originalPrice: 60,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 3,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: false,
      privacy: 'shared',
      chatDeletable: false
    }
  },
  'official-shared-3users-12months': {
    id: 'official-shared-3users-12months',
    productType: 'official-shared',
    userConfig: '3users',
    duration: '12months',
    productId: 248,
    product_days: 365,
    type: 'app3',
    product_name: 'ChatGPT $20 Plus Official Shared 3 Users 12 Months',
    nameKey: 'sku.officialShared.3users.12months.name',
    descriptionKey: 'sku.officialShared.3users.12months.description',
    price: 118.8,
    originalPrice: 240,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 3,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: false,
      privacy: 'shared',
      chatDeletable: false
    }
  },
  
  // 官网共享账号（6人共享）
  'official-shared-6users-1month': {
    id: 'official-shared-6users-1month',
    productType: 'official-shared',
    userConfig: '6users',
    duration: '1month',
    productId: 249,
    product_days: 30,
    type: 'app6',
    product_name: 'ChatGPT $20 Plus Official Shared 6 Users 1 Month',
    nameKey: 'sku.officialShared.6users.1month.name',
    descriptionKey: 'sku.officialShared.6users.1month.description',
    price: 4.9,
    originalPrice: 20,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 6,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: false,
      privacy: 'shared',
      chatDeletable: false
    }
  },
  'official-shared-6users-3months': {
    id: 'official-shared-6users-3months',
    productType: 'official-shared',
    userConfig: '6users',
    duration: '3months',
    productId: 250,
    product_days: 90,
    type: 'app6',
    product_name: 'ChatGPT $20 Plus Official Shared 6 Users 3 Months',
    nameKey: 'sku.officialShared.6users.3months.name',
    descriptionKey: 'sku.officialShared.6users.3months.description',
    price: 14.7,
    originalPrice: 60,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 6,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: false,
      privacy: 'shared',
      chatDeletable: false
    }
  },
  'official-shared-6users-12months': {
    id: 'official-shared-6users-12months',
    productType: 'official-shared',
    userConfig: '6users',
    duration: '12months',
    productId: 251,
    product_days: 365,
    type: 'app6',
    product_name: 'ChatGPT $20 Plus Official Shared 6 Users 12 Months',
    nameKey: 'sku.officialShared.6users.12months.name',
    descriptionKey: 'sku.officialShared.6users.12months.description',
    price: 58.8,
    originalPrice: 240,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 6,
      loginType: 'official',
      warranty: 'replacement',
      autoRenew: false,
      passwordChangeable: false,
      privacy: 'shared',
      chatDeletable: false
    }
  },
  
  // 网页共享托管账号（1人共享）
  'shared-1user-1month': {
    id: 'shared-1user-1month',
    productType: 'shared',
    userConfig: '1user',
    duration: '1month',
    productId: 252,
    product_days: 30,
    type: 'gpt',
    product_name: 'ChatGPT $20 Plus Web Shared Account 1 Month',
    nameKey: 'sku.sharedHosted.1user.1month.name',
    descriptionKey: 'sku.sharedHosted.1user.1month.description',
    price: 4.9,
    originalPrice: 20,
    currency: '$',
    features: {
      platform: 'web',
      users: 1,
      loginType: 'shared',
      warranty: 'monthly',
      autoRenew: false
    }
  },
  'shared-1user-3months': {
    id: 'shared-1user-3months',
    productType: 'shared',
    userConfig: '1user',
    duration: '3months',
    productId: 253,
    product_days: 90,
    type: 'gpt',
    product_name: 'ChatGPT $20 Plus Web Shared Account 3 Months',
    nameKey: 'sku.sharedHosted.1user.3months.name',
    descriptionKey: 'sku.sharedHosted.1user.3months.description',
    price: 14.7,
    originalPrice: 60,
    currency: '$',
    features: {
      platform: 'web',
      users: 1,
      loginType: 'shared',
      warranty: 'monthly',
      autoRenew: false
    }
  },
  'shared-1user-12months': {
    id: 'shared-1user-12months',
    productType: 'shared',
    userConfig: '1user',
    duration: '12months',
    productId: 254,
    product_days: 365,
    type: 'gpt',
    product_name: 'ChatGPT $20 Plus Web Shared Account 12 Months',
    nameKey: 'sku.sharedHosted.1user.12months.name',
    descriptionKey: 'sku.sharedHosted.1user.12months.description',
    price: 58.8,
    originalPrice: 240,
    currency: '$',
    features: {
      platform: 'web',
      users: 1,
      loginType: 'shared',
      warranty: 'monthly',
      autoRenew: false
    }
  },
  
  // MonkeyAI（1人独享）
  'monkeyai-1user-1month': {
    id: 'monkeyai-1user-1month',
    productType: 'monkeyai',
    userConfig: '1user',
    duration: '1month',
    productId: 255,
    product_days: 30,
    type: 'app1',
    product_name: 'MonkeyAI Premium Account 1 Month',
    nameKey: 'sku.monkeyai.1user.1month.name',
    descriptionKey: 'sku.monkeyai.1user.1month.description',
    price: 9.9,
    originalPrice: 19.9,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'custom',
      warranty: 'lifetime',
      autoRenew: false
    }
  },
  'monkeyai-1user-3months': {
    id: 'monkeyai-1user-3months',
    productType: 'monkeyai',
    userConfig: '1user',
    duration: '3months',
    productId: 256,
    product_days: 90,
    type: 'app1',
    product_name: 'MonkeyAI Premium Account 3 Months',
    nameKey: 'sku.monkeyai.1user.3months.name',
    descriptionKey: 'sku.monkeyai.1user.3months.description',
    price: 29.7,
    originalPrice: 59.7,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'custom',
      warranty: 'lifetime',
      autoRenew: false
    }
  },
  'monkeyai-1user-12months': {
    id: 'monkeyai-1user-12months',
    productType: 'monkeyai',
    userConfig: '1user',
    duration: '12months',
    productId: 257,
    product_days: 365,
    type: 'app1',
    product_name: 'MonkeyAI Premium Account 12 Months',
    nameKey: 'sku.monkeyai.1user.12months.name',
    descriptionKey: 'sku.monkeyai.1user.12months.description',
    price: 118.8,
    originalPrice: 238.8,
    currency: '$',
    features: {
      platform: 'web+app',
      users: 1,
      loginType: 'custom',
      warranty: 'lifetime',
      autoRenew: false
    }
  }
};

// 工具函数：根据维度获取SKU
export const getSkuByDimensions = (productType, userConfig, duration) => {
  const skuId = `${productType}-${userConfig}-${duration}`;
  return SKU_CONFIG[skuId] || null;
};

// 工具函数：根据产品类型获取所有SKU
export const getSkusByProductType = (productType) => {
  return Object.values(SKU_CONFIG).filter(sku => sku.productType === productType);
};

// 工具函数：根据用户配置获取所有SKU
export const getSkusByUserConfig = (userConfig) => {
  return Object.values(SKU_CONFIG).filter(sku => sku.userConfig === userConfig);
};

// 工具函数：获取特定产品类型和用户配置的所有有效期选项
export const getDurationsByProductType = (productType, userConfig) => {
  const skus = Object.values(SKU_CONFIG).filter(
    sku => sku.productType === productType && sku.userConfig === userConfig
  );
  return skus.map(sku => ({
    duration: sku.duration,
    price: sku.price,
    originalPrice: sku.originalPrice,
    currency: sku.currency
  }));
};

// 工具函数：根据SKU ID获取SKU信息
export const getSkuById = (skuId) => {
  return SKU_CONFIG[skuId] || null;
};

// 工具函数：生成SKU ID
export const generateSkuId = (productType, userConfig, duration) => {
  return `${productType}-${userConfig}-${duration}`;
};

// 工具函数：获取产品类型的所有用户配置
export const getUserConfigsByProductType = (productType) => {
  const skus = Object.values(SKU_CONFIG).filter(sku => sku.productType === productType);
  const userConfigs = [...new Set(skus.map(sku => sku.userConfig))];
  return userConfigs;
};

// 工具函数：获取产品的完整信息
export const getProductInfo = (productType, userConfig) => {
  const skus = Object.values(SKU_CONFIG).filter(
    sku => sku.productType === productType && sku.userConfig === userConfig
  );
  if (skus.length === 0) return null;
  
  const firstSku = skus[0];
  return {
    productType: firstSku.productType,
    userConfig: firstSku.userConfig,
    features: firstSku.features,
    durations: skus.map(sku => ({
      duration: sku.duration,
      price: sku.price,
      originalPrice: sku.originalPrice,
      productId: sku.productId
    }))
  };
};

// 产品类型说明配置
export const PRODUCT_TYPE_INFO = {
  'official': {
    aboutProduct: [
      '官方ChatGPT Plus账号，每月20美元套餐',
      '一人独享，账号密码专属于您',
      '支持GPT-4、DALL-E 3、Code Interpreter等最新模型',
      '优先访问新功能，响应速度更快',
      '无使用限制，可全天候使用',
      '终身质保，遇到问题免费更换'
    ],
    afterPurchase: [
      '账号信息（邮箱和密码）',
      '详细的使用教程和登录指南',
      '专属客服支持，24小时在线解答',
      '免费的账号安全保障服务',
      '定期的功能更新通知'
    ],
    notes: [
      '请勿与他人分享账号信息',
      '建议定期修改密码保障安全',
      '遇到任何问题请及时联系客服',
      '账号仅限个人使用，禁止商业用途',
      '请遵守OpenAI的使用条款'
    ]
  },
  'official-renewal': {
    aboutProduct: [
      '为您已有的ChatGPT账号续费Plus会员',
      '保留原账号的所有聊天记录和设置',
      '续费后立即生效，无需等待',
      '支持多次续费，价格优惠',
      '适用于所有官方ChatGPT账号'
    ],
    afterPurchase: [
      '续费成功确认邮件',
      '续费操作详细指南',
      '会员到期时间查询方法',
      '专属续费客服支持',
      '下次续费提醒服务'
    ],
    notes: [
      '请确保提供正确的账号信息',
      '续费前请确认账号状态正常',
      '续费时间会累加到当前会员期限',
      '如遇续费失败，将全额退款',
      '建议在会员到期前3天进行续费'
    ]
  },
  'official-shared': {
    aboutProduct: [
      '官方ChatGPT Plus账号，多人共享使用',
      '3人或6人共享，价格更实惠',
      '每人独立会话，互不干扰',
      '享受Plus会员所有权益',
      '适合团队或朋友一起使用',
      '共享但不共用，隐私有保障'
    ],
    afterPurchase: [
      '专属的登录链接和使用说明',
      '共享使用规则和注意事项',
      '独立的会话管理方法',
      '共享群组交流渠道',
      '技术支持和问题解答'
    ],
    notes: [
      '请遵守共享使用规则，文明使用',
      '不要删除他人的聊天记录',
      '合理安排使用时间，避免冲突',
      '遇到问题请先查看使用指南',
      '严禁进行违法违规操作'
    ]
  },
  'shared': {
    aboutProduct: [
      '托管型账号，通过网页直接使用',
      '无需登录，扫码即可访问',
      '支持多设备同时在线',
      '稳定可靠，专人维护',
      '最经济的ChatGPT使用方案',
      '适合轻度使用用户'
    ],
    afterPurchase: [
      '专属的访问链接和二维码',
      '详细的使用教程',
      '多设备登录方法',
      '使用时长查询方式',
      '客服联系方式'
    ],
    notes: [
      '请保管好您的访问链接',
      '不要在公共场合展示二维码',
      '建议收藏访问页面便于使用',
      '网络环境速度更快',
      '如遇无法访问请联系客服'
    ]
  },
  'monkeyai': {
    aboutProduct: [
      'AI Monkey自研AI服务平台',
      '集成多种主流AI模型',
      '一站式AI解决方案',
      '中文优化，使用更便捷',
      '持续更新，功能不断完善',
      '本土化服务，响应更快'
    ],
    afterPurchase: [
      'MonkeyAI账号和登录信息',
      '平台使用指南和功能介绍',
      'API调用文档（如适用）',
      'VIP会员专属权益说明',
      '更新通知订阅服务'
    ],
    notes: [
      '请遵守平台使用规范',
      '合理使用API调用额度',
      '注意保护账号安全',
      '及时关注功能更新',
      '欢迎提供反馈和建议'
    ]
  }
};